import React from 'react';
import HighlightText from '../HomePage/HighlightText';

function Quote(props) {
    return (
        <div className='text-richblack-50 text-2xl text-center w-[70%]'>
            "We are passionate about revolutionizing the way we learn. Our innovative platform
            <HighlightText text={"combines technology"}/>
            ,
            <span className='font-bold bg-gradient-to-r from-[#FF512F] text-transparent via-[#FF512F] to-[#F09819] bg-clip-text'>
                {" "}
                expertise
            </span>
            , and community to create an
            <span className='font-bold bg-gradient-to-r from-[#E65C00] text-transparent via-[#E65C00] to-[#F9D423] bg-clip-text'>
                {" "}
                unparalleled educational experience.
            </span>
            "
        </div>
    );
}

export default Quote;